// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 0;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 60px;
  position: relative;
}

/* Hamburger Menu (Hidden on Desktop) */
.hamburger-menu {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 25px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
  margin-right: 16px;
}

.hamburger-line {
  width: 100%;
  height: 3px;
  background-color: #E8D5B7;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.hamburger-line.open:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.hamburger-line.open:nth-child(2) {
  opacity: 0;
}

.hamburger-line.open:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

.nav-brand {
  display: flex;
  align-items: center;
}

.nav-logo {
  height: 68px;
  width: auto;
  max-width: 230px;
  filter: brightness(0) saturate(100%) invert(91%) sepia(13%) saturate(475%) hue-rotate(332deg) brightness(97%) contrast(91%);
  transition: filter 0.3s ease;
}

.nav-logo:hover {
  filter: brightness(0) saturate(100%) invert(95%) sepia(8%) saturate(624%) hue-rotate(333deg) brightness(102%) contrast(92%);
}

.nav-menu {
  display: flex;
  gap: 0;
}

.nav-item {
  background: none;
  border: none;
  color: #E8D5B7;
  padding: 20px 14px;
  font-size: 0.88rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  text-transform: uppercase;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  letter-spacing: 0.4px;
  white-space: nowrap;
}

.nav-item:hover {
  color: #F7E9D2;
  background: rgba(255, 255, 255, 0.1);
}

.nav-item.active {
  color: #D4A574;
  background: rgba(212, 165, 116, 0.1);
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #D4A574;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.cart-button {
  position: relative;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #E8D5B7;
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
}

.cart-button:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  color: #F7E9D2;
  transform: translateY(-2px);
}

.cart-button svg {
  width: 24px;
  height: 24px;
}

.cart-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #DC3545;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.nav-language {
  display: flex;
  gap: 8px;
}

.lang-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #E8D5B7;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.lang-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  color: #F7E9D2;
}

.lang-btn.active {
  background: #D4A574;
  border-color: #D4A574;
  color: #3D1818;
  box-shadow: 0 2px 8px rgba(212, 165, 116, 0.3);
}

/* Mobile Menu Styles */
@media (max-width: 768px) {
  .hamburger-menu {
    display: flex;
    order: -1; /* Place it first in nav-actions */
  }

  .nav-menu {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    width: 100%;
    background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);
    flex-direction: column;
    padding: 20px 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease, opacity 0.3s ease;
    z-index: 999;
    max-height: calc(100vh - 60px);
    overflow-y: auto;
    transform: translateY(-100%);
    opacity: 0;
    pointer-events: none;
  }

  .nav-menu.mobile-open {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }

  .nav-item {
    width: 100%;
    text-align: left;
    padding: 16px 24px;
    border-radius: 0;
    justify-content: flex-start;
    border-bottom: 1px solid rgba(232, 213, 183, 0.1);
  }

  .nav-item:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .nav-item.active {
    background: rgba(212, 165, 116, 0.15);
    border-left: 4px solid #D4A574;
  }

  .nav-item.active::after {
    display: none;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .nav-container {
    padding: 0 15px;
    height: 50px;
  }
  
  .nav-brand h1 {
    font-size: 1.3rem;
  }
  
  .nav-menu {
    gap: 0;
  }
  
  .nav-item {
    padding: 15px 16px;
    font-size: 0.9rem;
  }
  
  .lang-btn {
    padding: 6px 12px;
    font-size: 0.8rem;
  }
}

@media (max-width: 600px) {
  .nav-container {
    flex-direction: column;
    height: auto;
    padding: 10px 15px;
  }
  
  .nav-brand h1 {
    margin-bottom: 10px;
  }
  
  .nav-menu {
    margin-bottom: 10px;
  }
  
  .nav-item {
    padding: 12px 14px;
    font-size: 0.85rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/NavBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,6DAA6D;EAC7D,0CAA0C;EAC1C,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,2HAA2H;EAC3H,4BAA4B;AAC9B;;AAEA;EACE,2HAA2H;AAC7H;;AAEA;EACE,aAAa;EACb,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;IACb,SAAS,EAAE,kCAAkC;EAC/C;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,6DAA6D;IAC7D,sBAAsB;IACtB,eAAe;IACf,yCAAyC;IACzC,kDAAkD;IAClD,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,4BAA4B;IAC5B,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,iDAAiD;EACnD;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,qCAAqC;IACrC,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF","sourcesContent":[".navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  padding: 0;\n}\n\n.nav-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  height: 60px;\n  position: relative;\n}\n\n/* Hamburger Menu (Hidden on Desktop) */\n.hamburger-menu {\n  display: none;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 30px;\n  height: 25px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 1001;\n  margin-right: 16px;\n}\n\n.hamburger-line {\n  width: 100%;\n  height: 3px;\n  background-color: #E8D5B7;\n  transition: all 0.3s ease;\n  border-radius: 2px;\n}\n\n.hamburger-line.open:nth-child(1) {\n  transform: rotate(45deg) translate(8px, 8px);\n}\n\n.hamburger-line.open:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger-line.open:nth-child(3) {\n  transform: rotate(-45deg) translate(7px, -7px);\n}\n\n.nav-brand {\n  display: flex;\n  align-items: center;\n}\n\n.nav-logo {\n  height: 68px;\n  width: auto;\n  max-width: 230px;\n  filter: brightness(0) saturate(100%) invert(91%) sepia(13%) saturate(475%) hue-rotate(332deg) brightness(97%) contrast(91%);\n  transition: filter 0.3s ease;\n}\n\n.nav-logo:hover {\n  filter: brightness(0) saturate(100%) invert(95%) sepia(8%) saturate(624%) hue-rotate(333deg) brightness(102%) contrast(92%);\n}\n\n.nav-menu {\n  display: flex;\n  gap: 0;\n}\n\n.nav-item {\n  background: none;\n  border: none;\n  color: #E8D5B7;\n  padding: 20px 14px;\n  font-size: 0.88rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  text-transform: uppercase;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  letter-spacing: 0.4px;\n  white-space: nowrap;\n}\n\n.nav-item:hover {\n  color: #F7E9D2;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.nav-item.active {\n  color: #D4A574;\n  background: rgba(212, 165, 116, 0.1);\n}\n\n.nav-item.active::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: #D4A574;\n}\n\n.nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.cart-button {\n  position: relative;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #E8D5B7;\n  padding: 10px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n}\n\n.cart-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: #F7E9D2;\n  transform: translateY(-2px);\n}\n\n.cart-button svg {\n  width: 24px;\n  height: 24px;\n}\n\n.cart-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  background: #DC3545;\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.7rem;\n  font-weight: 700;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.nav-language {\n  display: flex;\n  gap: 8px;\n}\n\n.lang-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #E8D5B7;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.lang-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: #F7E9D2;\n}\n\n.lang-btn.active {\n  background: #D4A574;\n  border-color: #D4A574;\n  color: #3D1818;\n  box-shadow: 0 2px 8px rgba(212, 165, 116, 0.3);\n}\n\n/* Mobile Menu Styles */\n@media (max-width: 768px) {\n  .hamburger-menu {\n    display: flex;\n    order: -1; /* Place it first in nav-actions */\n  }\n\n  .nav-menu {\n    position: fixed;\n    top: 60px;\n    left: 0;\n    right: 0;\n    width: 100%;\n    background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);\n    flex-direction: column;\n    padding: 20px 0;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n    transition: transform 0.3s ease, opacity 0.3s ease;\n    z-index: 999;\n    max-height: calc(100vh - 60px);\n    overflow-y: auto;\n    transform: translateY(-100%);\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  .nav-menu.mobile-open {\n    transform: translateY(0);\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .nav-item {\n    width: 100%;\n    text-align: left;\n    padding: 16px 24px;\n    border-radius: 0;\n    justify-content: flex-start;\n    border-bottom: 1px solid rgba(232, 213, 183, 0.1);\n  }\n\n  .nav-item:hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n\n  .nav-item.active {\n    background: rgba(212, 165, 116, 0.15);\n    border-left: 4px solid #D4A574;\n  }\n\n  .nav-item.active::after {\n    display: none;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .nav-container {\n    padding: 0 15px;\n    height: 50px;\n  }\n  \n  .nav-brand h1 {\n    font-size: 1.3rem;\n  }\n  \n  .nav-menu {\n    gap: 0;\n  }\n  \n  .nav-item {\n    padding: 15px 16px;\n    font-size: 0.9rem;\n  }\n  \n  .lang-btn {\n    padding: 6px 12px;\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .nav-container {\n    flex-direction: column;\n    height: auto;\n    padding: 10px 15px;\n  }\n  \n  .nav-brand h1 {\n    margin-bottom: 10px;\n  }\n  \n  .nav-menu {\n    margin-bottom: 10px;\n  }\n  \n  .nav-item {\n    padding: 12px 14px;\n    font-size: 0.85rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
